import { setTerm } from './helpers';

export const setIsFirstFloor = setTerm('is_first_floor');
